import React from "react";
import { Row, Col, Button } from "components/common";
import { Wrapper } from "./ExpensesCard.styled";
import ExpensesListCard from "./ExpensesListCard/ExpensesListCard";
import filter from "../../../assets/images/filter.png";
import { getUserPermissions } from "utils/text";
const ExpensesCard = ({
  setIsOpen,
  getExpenseData,
  deleteExpense,
  setExpenseData,
  leadData,
  expenseData,
  userData,
  setEditData,
  setIsdrawOpen
}) => {
  return (
    <Wrapper>
      <Row>
        <Col span={24}>
          {getUserPermissions("add-new-expense-action") && (
            <Button
              title="Add Expense"
              className="add-expense"
              onClick={() => {
                setIsOpen(true);
                setEditData(null);
              }}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col span={24} className="filter">
          <img
            src={filter}
            className="pointer"
            onClick={() => {
              setIsdrawOpen(true);
            }}
            alt=""
          />
        </Col>
      </Row>
      <Row gutter={[15, 15]}>
        {getExpenseData?.map((item) => {
          return (
            <Col xs={24} md={12}>
              <ExpensesListCard
                leadData={leadData}
                expenseData={expenseData}
                getExpenseData={item}
                setIsOpen={setIsOpen}
                setExpenseData={setExpenseData}
                deleteExpense={deleteExpense}
                userData={userData}
                setEditData={setEditData}
              />
            </Col>
          );
        })}
      </Row>
    </Wrapper>
  );
};

export default ExpensesCard;
